<template>

  <div class="no-data d-flex align-center justify-center" :class="{ small, medium }">
    <div class="text-center">
      <slot></slot>
    </div>
  </div>

</template>

<script>
  export default {
    name: 'no-data',

    props: {
      small: Boolean,
      medium: Boolean
    }
  }
</script>

<style scoped lang="scss">

  .no-data {
    height: 100%;
    font-size: 30px;
    color: rgba(150, 150, 150, 0.8);
    font-weight: 200;

    &.medium {
      font-size: 24px;
    }

    &.small {
      font-size: 20px;
    }
  }

</style>
